import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, Modal, Table, Space } from "antd"; 
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddPrejudice from "./AddPrejudice";
import ActionDropdown from "../../production/components/ActionDropdown";

const Prejudices = () => {
  const [prejudices, setPrejudices] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedPrejudice, setSelectedPrejudice] = useState(null);

  const handleShow = (edit = false, prejudice = null) => {
    setEditMode(edit);
    setSelectedPrejudice(prejudice);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedPrejudice(null); 
    setEditMode(false); 
  };

  const showDeleteConfirm = (codeId) => {
    Modal.confirm({ 
      title: "Êtes-vous sûr de vouloir supprimer ce préjudice?",
      icon: <ExclamationCircleFilled />,
      content: "Cette action est irréversible.",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk() {
        deletePrejudice(codeId);
      },
    });
  };

  const deletePrejudice = (codeId) => {
    axios
      .delete(`${API_URL}/api/prejudice/${codeId}`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      })
      .then(() => {
        setPrejudices((prevPrejudices) =>
          prevPrejudices.filter((p) => p.codeId !== codeId)
        );
        toast.success("Préjudice supprimé avec succès");
      })
      .catch((err) => {
        console.error(
          "Erreur lors de la suppression du préjudice :",
          err.response?.data || err.message
        );
        toast.error("Erreur lors de la suppression du préjudice");
      });
  };

  const loadPrejudices = () => {
    axios
      .get(`${API_URL}/api/prejudice`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const sortedPrejudices = res.data.sort((a, b) => b.codeId - a.codeId);
        setPrejudices(sortedPrejudices);
      })
      .catch((err) => {
        console.error(
          "Erreur lors du chargement des préjudices :",
          err.response?.data || err.message
        );
        toast.error("Erreur lors du chargement des préjudices");
      });
  };

  useEffect(() => {
    loadPrejudices();
  }, []);

  const columns = [
    {
      title: "Libellé",
      dataIndex: "libellePrejudice",
      key: "libellePrejudice",
    },
    {
      title: "Montant",
      dataIndex: "montant",
      key: "montant",
      render: (montant) => montant,
    },
    {
      title: "Actions",
      key: "actions",
      

render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShow(true, record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => showDeleteConfirm(record.codeId),
            },
          ]}
        />
      ),



      
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="PARAMETRES_SINISTRES" />

        <div className="layout-page">
          <NavBar />

          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow(false)} 
              >
                Ajouter un nouveau préjudice
              </Button>
              <div className="card">
                <h5 className="card-header">Liste des préjudices</h5>
                <Table
                  columns={columns}
                  dataSource={prejudices}
                  rowKey="codeId" 
                  pagination={{ pageSize: 10 }} 
                />
              </div>

              <Modal
                open={showModal} 
                footer={null} 
                onCancel={handleClose} 
                destroyOnClose={true} 
              >
                <AddPrejudice
                  handleClose={handleClose} 
                  editMode={editMode}
                  selectedPrejudice={selectedPrejudice}
                  prejudices={prejudices} 
                  onActionComplete={loadPrejudices} 
                />
              </Modal>
            </div>

            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default Prejudices;
